<div class="container">
  <!-- your-component.component.html -->
  <div class="d-flex justify-content-end m-3">
    <button mat-raised-button (click)="addReport()" color="primary"><mat-icon>add</mat-icon> Add</button>
  </div>
  <div class="card">
    <table mat-table [dataSource]="dataSource" style="width: 100%" matSort class="body">
      <!-- Define columns -->
      <ng-container matColumnDef="sr">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Sr </th>
        <td mat-cell *matCellDef="let element;let i =index"> {{ i+1 }} </td>
      </ng-container>
      <ng-container matColumnDef="childName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre </th>
        <td mat-cell *matCellDef="let element"> {{ element.centreCode }} </td>
      </ng-container>
      <ng-container matColumnDef="totalSessions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Total Sessions </th>
        <td mat-cell *matCellDef="let element"> {{ element.totalSessions }} </td>
      </ng-container>
      <ng-container matColumnDef="from">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> From </th>
        <td mat-cell *matCellDef="let element"> {{ element.from.toDate() |date:'dd/MM/yyyy' }} </td>
      </ng-container>
      <ng-container matColumnDef="to">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> To </th>
        <td mat-cell *matCellDef="let element"> {{ element.to.toDate()|date:'dd/MM/yyyy'}} </td>
      </ng-container>
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
        <td mat-cell *matCellDef="let element"> {{ element.createdAt.toDate()|date:'dd/MM/yyyy hh:mm:aa' }} </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>  </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button (click)="ViewReport(element.id)" color="primary"><mat-icon>edit</mat-icon> </button>
          <button mat-icon-button (click)="deleteReport(element.id)" color="warn"><mat-icon>delete</mat-icon> </button>
        </td>
      </ng-container>
      <!-- Repeat for other columns -->

      <!-- Render rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
